module.exports = __webpack_public_path__ + "static/img/slogn-cn.f5ea3b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/slogn/slogn-cn.png
// module id = mfh6
// module chunks = 1